import React       from "react";
import {Container} from "./styles";

export const Image = ({data}) => (
  <Container>{data}</Container>
)
